const data = [
  {
    id: "01",
    img: "../../assets/cello.jpg",
    alt: "cello",
    name: "Cello",
    info: "lorem iLorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra nec, mattis ac neque.",
    price: 210,
  },
  {
    id: "02",
    img: "../../assets/imgs/drum.jpg",
    alt: "drum",
    name: "Drum",
    info: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra nec, mattis ac neque.",
    price: 150,
  },
  {
    id: "03",
    img: "../../assets/imgs/piano.jpg",
    alt: "piano",
    name: "Piano",
    info: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra nec, mattis ac neque.",
    price: 350,
  },
  {
    id: "04",
    img: "../../assets/imgs/violin.jpg",
    alt: "violin",
    name: "Violin",
    info: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra nec, mattis ac neque.",
    price: 65,
  },
  {
    id: "05",
    img: "../../assets/imgs/saxophone.jpg",
    alt: "saxophone",
    name: "Saxophone",
    info: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra nec, mattis ac neque.",
    price: 82,
  },
  {
    id: "06",
    img: "../../assets/imgs/xylophone.jpg",
    alt: "xylophone",
    name: "Xylophone",
    info: "loremLorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra nec, mattis ac neque. ",
    price: 82,
  },
  {
    id: "07",
    img: "../../assets/imgs/Guitar.jpg",
    alt: "Guitar",
    name: "Guitar",
    info: "loremLorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra nec, mattis ac neque. ",
    price: 40,
  },
  {
    id: "08",
    img: "../../assets/imgs/Blue-Guitar.jpg",
    alt: "Blue Guitar",
    name: "Blue-Guitar",
    info: "loremLorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra nec, mattis ac neque. ",
    price: 240,
  },
  {
    id: "09",
    img: "../../assets/imgs/Microphone.jpg",
    alt: "Microphone",
    name: "Microphone",
    info: "loremLorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra nec, mattis ac neque. ",
    price: 20,
  },
  {
    id: "10",
    img: "../../assets/imgs/Headphones.jpg",
    alt: "Headphones",
    name: "Headphones",
    info: "loremLorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra nec, mattis ac neque. ",
    price: 10,
  },
  {
    id: "11",
    img: "../../assets/imgs/Harp.jpg",
    alt: "Harp",
    name: "Harp",
    info: "loremLorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra nec, mattis ac neque. ",
    price: 100,
  },
  {
    id: "12",
    img: "../../assets/imgs/Synthesizer.jpg",
    alt: "Synthesizer",
    name: "Synthesizer",
    info: "loremLorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra nec, mattis ac neque. ",
    price: 530,
  },
  {
    id: "13",
    img: "../../assets/imgs/Keyboard.jpg",
    alt: "Keyboard",
    name: "Keyboard",
    info: "loremLorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra nec, mattis ac neque. ",
    price: 35,
  },
  {
    id: "14",
    img: "../../assets/imgs/Woodwind.jpg",
    alt: "Woodwind",
    name: "Woodwind",
    info: "loremLorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra nec, mattis ac neque. ",
    price: 55,
  },
  {
    id: "15",
    img: "../../assets/imgs/Tambourine.jpg",
    alt: "Tambourine",
    name: "Tambourine",
    info: "loremLorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra nec, mattis ac neque. ",
    price: 10,
  },
  {
    id: "16",
    img: "../../assets/imgs/Stand.jpg",
    alt: "Stand",
    name: "Stand",
    info: "loremLorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra nec, mattis ac neque. ",
    price: 12,
  },
];

export default data;
